import axios from "../../../../../../api/axiosInstance";
import {
  FetchROIDashboardDataRequest,
  FetchROIDashboardDataResponse,
} from "./types";

export const fetchROIDashboardData = async (
  requestData?: FetchROIDashboardDataRequest,
): Promise<FetchROIDashboardDataResponse> => {
  const response = await axios.get<FetchROIDashboardDataResponse>(
    `/api/private/stochastic/roi-dashboard`,
    { params: requestData },
  );

  return response.data;
};
